import { Box, Card, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FC, useCallback } from 'react';
import { ImageField, useInput } from 'react-admin';
import 'react-tabs/style/react-tabs.css';
import _debounce from 'lodash/debounce';
import ReactMarkdown from 'react-markdown';
// import RichTextInput from 'ra-input-rich-text';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
// import SimpleMdeReact from 'react-simplemde-editor/dist/SimpleMdeReact';
// import 'easymde/dist/easymde.min.css';
// import * as MarkdownEditor from '@uiw/react-markdown-editor';
import '../index.css';
import TitleText from '../../common/title-text';
import DateTimePicker from 'react-datetime-picker';
import SubtitleText from '../../common/subtitle-text';

interface Props {
  isBlocked: boolean;
  changeStatus: () => void;
  isShow: boolean;
}

interface SelectCountries {
  id: string;
  name: string;
}
let statuses = ['draft', 'publish', 'personal'];

const BlogDatePicker = (props) => {
  const {
    input: { name, onChange, value },
    meta: { touched, error },
    isRequired,
  } = useInput(props);

  function handleChange(value: Date) {
    if (value) onChange(value.toISOString());
  }

  return (
    <React.Fragment>
      <Box>
        <DateTimePicker
          // disabled={state.isActiveDreamHome}
          value={value ? new Date(value) : ''}
          format={'dd-MM-y h:mm:ss a'}
          onChange={handleChange}
          maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
          minDate={new Date('2000-01-18T19:55:00.000+00:00')}
          disableClock
        />
      </Box>
    </React.Fragment>
  );
};

export default BlogDatePicker;
